import { Component, OnInit } from '@angular/core';
import { GridBaseComponent } from '../../base/shared/grid-base/grid-base.component';
import { ClientService } from '../../base/services/client/client.service';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { DeviceInteractionService } from './device-interaction.service';
import { DataManager } from '@syncfusion/ej2-data';
import { AvpCustomAdaptor } from '../../base/shared/syncfusion/avp-custom-adaptor';
import { SpinnerService } from '../../base/spinner/spinner.service';
import {
  ClientDTO,
  ExecuteZoneDeviceCommandDTO,
  FilterDTO,
  FilterOperator,
  SortDirection,
  ZoneClient,
  ZoneDeviceBrand,
  ZoneDeviceType,
} from '../../base/models/models.swagger.generated';
import { DropDownConstantsFactory } from '../../base/shared/syncfusion/dropdown-constants-factory';
import { filter, startWith, switchMap } from 'rxjs/operators';
import { UntypedFormBuilder, ReactiveFormsModule } from '@angular/forms';
import { TooltipModule } from '@syncfusion/ej2-angular-popups';
import { GridModule } from '@syncfusion/ej2-angular-grids';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import { ClientAutocompleteComponent } from '../../base/shared/client-autocomplete/client-autocomplete.component';
import { TitleBarComponent } from '../../base/shared/title-bar/title-bar.component';

@Component({
    selector: 'app-device-interaction',
    templateUrl: './device-interaction.component.html',
    styleUrls: ['./device-interaction.component.scss'],
    imports: [
        TitleBarComponent,
        ReactiveFormsModule,
        ClientAutocompleteComponent,
        DropDownListModule,
        GridModule,
        TooltipModule,
        TranslateModule,
    ],
    providers: [DeviceInteractionService]
})
export class DeviceInteractionComponent extends GridBaseComponent implements OnInit {

  public dropdownSettings = DropDownConstantsFactory.createStandardClientDropdownSettings();
  public zoneDropdownValues = [];

  public filterForm = this.fb.group({
    zone: [''],
  });

  constructor(clientService: ClientService,
    translate: TranslateService,
    private fb: UntypedFormBuilder,
    private zoneClient: ZoneClient,
    private deviceInteractionService: DeviceInteractionService,
    private spinnerService: SpinnerService) {
    super(clientService, translate, deviceInteractionService);
    this.deviceInteractionService.clientId = this.clientService.selectedClient?.id;
  }

  public override get selectedClient(): ClientDTO {
    return this.clientService.selectedClient;
  }

  public override set selectedClient(value: ClientDTO) {
    if (this.clientService.selectedClient != value) {
      this.clientService.selectedClient = value;
      this.deviceInteractionService.clientId = value.id;
      this.onClientSelected(value);
    }
  }

  public onRefresh(): void {
    this.grid.refresh();
  }

  public ngOnInit(): void {
    this.data = new DataManager({
      adaptor: new AvpCustomAdaptor(this.deviceInteractionService, this.spinnerService),
    });

    this.clientSelected$
      .pipe(
        startWith(this.clientService.selectedClient?.id),
        filter(c => !!c),
        switchMap(clientId => {
          const groupFilter = new FilterDTO({
            isComplex: false,
            field: 'IsGroupingElement',
            operator: FilterOperator.Equal,
            value: 'false',
          });

          return this.zoneClient.searchZones(clientId, [groupFilter], 0, 0, 'Id', SortDirection.Ascending);
        }),
      )
      .subscribe(zones => {
        this.zoneDropdownValues = zones.items
          .filter(z => !z.isGroupingElement)
          .map(z => ({ name: z.name, id: z.id }));
      });

    this.filterForm.get('zone').valueChanges
      .subscribe(zoneId => {
        this.deviceInteractionService.zoneIds = [zoneId];
        this.grid.refresh();
      });
  }

  public dataBound(args): void {
    this.grid.autoFitColumns();
  }



  public getDeviceType(type: ZoneDeviceType): string {
    return 'i18n.shared.zone-device-enums.device-type.' + ZoneDeviceType[type];
  }

  public getDeviceBrand(brand: ZoneDeviceBrand): string {
    return 'i18n.shared.zone-device-enums.brand.' + ZoneDeviceBrand[brand];
  }

  protected getEditDialogTitleParams(rowData: any): any {
    return '';
  }

  protected initializeEditForm(data: any): void {
  }

  public executeDeviceCommand(deviceId: number, command: any, position: string): void {
    this.deviceInteractionService.executeDeviceCommand(new ExecuteZoneDeviceCommandDTO({ command, deviceId }))
      .subscribe(() => {
        this.grid.refresh();
        this.deviceInteractionService.observeCommandStatus(deviceId, position).subscribe(() => {
          this.grid.refresh();
        });
      });
  }
}
